export interface FeatureSwitchItem {
  type?: number; // 功能类型的数字枚举
  status?: boolean; // 功能状态
  manage_permission?: boolean; // 组织者/主持人是否有功能的管理权限
  manage_default_status?: boolean; // 权限的默认状态
  detail?: string | null;
}

// 功能枚举
export enum SwitchType {
  // ——————————admin功能开关部分————————————
  AMBIENT_SOUND = 'ambient_sound', //环境音
  PRIVATE_CHAT = 'private_chat', // 私聊
  CARD = 'card', // 名片
  DANMAKU = 'danmaku', // 弹幕
  ACTION = 'action', //动作
  // YAOTAI_LOGO, // 瑶台logo
  // TECHNOLOGY_SUPPORT, // 技术支持
  // OFFICAL_ENTER, // 官网入口
  UPDATE_ACTION = 'activity_update', // 更新活动
  ADD_VENUE = 'add_venue', // 添加场地
  MSG_SIGN = 'msg_sign',
  WEIMEI_CONFIG = 'game_play_conf',
  LIVE_CONFIG = 'live_stream', // 直播拉流
  STATISTIC = 'statistic', // 数据概览
  FACE_EDITOR = 'face_editor', // 面容编辑
  FACE_AI = 'face_ai', // 智能捏脸
  SHAPE_EDITOR = 'shape_editor', // 形象编辑
  AGENDA_DISPLAY = 'agenda_display', // 议程显示
  ACTIVITY_DATA = 'activity_data', // 活动流量
  NPC_TEXT_INTRO = 'npc_text_intro', // 文本介绍
  NPC_VOICE_BROAD = 'npc_voice_broad', // 语音播报
  NPC_INTELL_DIALOG = 'npc_intell_dialog', // 智能对话
  PROP_MALL = 'prop_mall', // 道具商店
  PRIZE_MALL = 'prize_mall', // 奖品商店
  FACIAL_TRANSFER = 'facial_transfer', //表情迁移,
  SUBTITLE_TRANSLATION = 'subtitle_translation', // 字幕翻译
}

// 后端返回值的Item项
export interface FeatureSwitchFetchItem extends FeatureSwitchItem {
  // switch_flag: boolean; 功能配置的标识(当前版本暂无此字段)
}

// 启用服务端反垃圾传递参数
export type ServiceAntiGarbageParam = {
  switch_type: AntiSpamSwitchType;
  activity_id: string;
};

export enum AntiSpamSwitchType {
  // ——————————reception反垃圾开关部分————————————
  ANTISPAM_MASTER = 'antispam_master', // 反垃圾总开关
  ANTISPAM_PLAYER_NAME = 'antispam_player_name', // 参会人员信息（昵称）
  ANTISPAM_PLAYER_CUSTOM_TITLE = 'antispam_player_custom_title', // 参会人员信息（头衔）
  ANTISPAM_PLAYER_INFO = 'antispam_player_info', // 参会人员信息（邮箱、职衔、组织）
  ANTISPAM_PLAYER_IMAGE = 'antispam_player_image', // 参会人员信息（照片）
  ANTISPAM_DANMAKU = 'antispam_danmaku', // 弹幕设置
  ANTISPAM_NOTICE = 'antispam_notice', // 信息配置（公告）
  ANTISPAM_VENUE_IMAGE = 'antispam_venue_image', // 场地管理（通用配置）
  ANTISPAM_DISPLAY_BOARD_ASSET = 'antispam_display_board_asset', // 场地配置（展板名称等）
  ANTISPAM_ACTIVITY_NAME = 'antispam_activity_name', // 活动名称
  ANTISPAM_LOGIN_IMAGE = 'antispam_login_image', // 登录页配置（背景）
  ANTISPAM_NPC_CORPUS_FILE = 'antispam_npc_corpus_file', // 语料文件
}

// 功能开关组枚举
export enum SwitchGroupEnum {
  Func = 1, // 功能开关
  LogPage = 2, // 登录页
  Oem = 3, // 品牌配置
  EmailTemplate = 5, // 邮件模板
  AntiSpam = 6, // 反垃圾
  Tourist = 7, // 游客
  Space = 8, // 空间
}

export type SwitchTypeKeys = 'FUNC' | 'LOGPATE' | 'ACTIVITY_OEM' | 'EMAILTEMPLATE' | 'ANTISPAM' | 'TICKET';

export interface FeatureSwitchParams {
  switch_conf: FeatureSwitchItem[];
}
